<form class="contact-form" [formGroup]="userForm" novalidate *ngIf="environment.webBuild">
	<h2 class="contact-form__title">{{ 'FORM.TITLE' | translate }}</h2>
	<div class="contact-form__row">
		<div class="contact-form__field contact-form__field--half">
			<label class="contact-form__label contact-form__label--highlight">{{ 'FORM.LABEL.TEXT' | translate }}</label>
			<textarea value="" class="contact-form__input contact-form__input--textarea" formControlName="text"></textarea>
		</div>
	</div>
	<div class="contact-form__row">
		<div class="contact-form__field contact-form__field--half">
			<label class="contact-form__label">{{ 'FORM.LABEL.FILES' | translate }}</label>
			<div class="upload">
				<div class="upload__list">
					<div *ngFor="let file of files; let i = index" class="upload__file" (click)="onRemoveFile(i)">
						<div class="upload__name">{{ file.name }}</div>
					</div>
				</div>
				<div class="upload__add">
					<div class="upload__button" [ngClass]="{'upload__button--deactivated': files?.length >= filesMax}">
						<input class="upload__input" [attr.disabled]="files?.length >= filesMax ? '' : null" [ngClass]="{'upload__input--deactivated': files?.length >= filesMax}" type="file" (change)="onAddFile($event)" accept="application/pdf,image/jpeg,image/png,application/zip,zip">
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="contact-form__row">
		<div class="contact-form__field contact-form__field--half">
			<label class="contact-form__label">{{ 'FORM.LABEL.EMAIL' | translate }}</label>
			<input value="" class="contact-form__input contact-form__input--text" formControlName="email" />
		</div>
	</div>
	<div class="contact-form__row">
		<div class="contact-form__field contact-form__field--half">
			<label class="contact-form__label">{{ 'FORM.LABEL.SALUTATION' | translate }}</label>
			<select class="contact-form__input contact-form__input--select" formControlName="salutation">
				<option value="">{{ 'FORM.SALUTATION.CHOOSE' | translate }}</option>
				<option value="anrede_frau">{{ 'FORM.SALUTATION.MRS' | translate }}</option>
				<option value="anrede_herr">{{ 'FORM.SALUTATION.MR' | translate }}</option>
			</select>
		</div>
		<div class="contact-form__field contact-form__field--half">
			<label class="contact-form__label">{{ 'FORM.LABEL.TITLE' | translate }}</label>
			<input value="" class="contact-form__input contact-form__input--text" formControlName="title" />
		</div>
	</div>
	<div class="contact-form__row">
		<div class="contact-form__field contact-form__field--half">
			<label class="contact-form__label">{{ 'FORM.LABEL.NAME' | translate }}</label>
			<input value="" class="contact-form__input contact-form__input--text" formControlName="name" />
		</div>
		<div class="contact-form__field contact-form__field--half">
			<label class="contact-form__label">{{ 'FORM.LABEL.SURNAME' | translate }}</label>
			<input value="" class="contact-form__input contact-form__input--text" formControlName="surname" />
		</div>
	</div>
	<div class="contact-form__row">
		<div class="contact-form__field contact-form__field--half">
			<label class="contact-form__label">{{ 'FORM.LABEL.COMPANY' | translate }}</label>
			<input value="" class="contact-form__input contact-form__input--text" formControlName="company" />
		</div>
		<div class="contact-form__field contact-form__field--half">
			<label class="contact-form__label">{{ 'FORM.LABEL.POSITION' | translate }}</label>
			<input value="" class="contact-form__input contact-form__input--text" formControlName="position" />
		</div>
	</div>
	<div class="contact-form__row contact-form__row--no-margin">
		<div class="contact-form__field contact-form__field--checkbox checkbox">
			<input id="privacy" type="checkbox" value="1" class="contact-form__input contact-form__input--checkbox" formControlName="policy" />
			<label for="privacy" class="checkbox__box">
				<i class="fa fa-check checkbox__check" [ngClass]="{'checkbox__check--active': userForm.controls['policy'].value}"></i>
			</label>
			<div class="checkbox__label">{{ 'FORM.LABEL.PRIVACY_POLICY' | translate }}</div>
		</div>
	</div>

	<div class="contact-form__row contact-form__row--no-margin">
		<div class="contact-form__field contact-form__field--checkbox checkbox">
			<input id="contact" type="checkbox" value="1" class="contact-form__input contact-form__input--checkbox" formControlName="contact" />
			<label for="contact" class="checkbox__box">
				<i class="fa fa-check checkbox__check" [ngClass]="{'checkbox__check--active': userForm.controls['contact'].value}"></i>
			</label>
			<div class="checkbox__label">{{ 'FORM.LABEL.CONTACT' | translate }}</div>
		</div>
	</div>
	<!--
	<div class="contact-form__row contact-form__row--no-margin">
		<div class="contact-form__field contact-form__field--checkbox checkbox">
			<input id="postal" type="checkbox" value="1" class="contact-form__input contact-form__input--checkbox" formControlName="postal" />
			<label for="postal" class="checkbox__box">
				<i class="fa fa-check checkbox__check" [ngClass]="{'checkbox__check--active': userForm.controls['postal'].value}"></i>
			</label>
			<div class="checkbox__label">{{ 'FORM.LABEL.POSTAL' | translate }}</div>
		</div>
	</div>
	-->
	<input id="postal" type="hidden" value="0" class="contact-form__input contact-form__input--checkbox" formControlName="postal" />
	<div class="contact-form__row">
		<div class="contact-form__field contact-form__field--checkbox checkbox">
			<input id="electronic" type="checkbox" value="1" class="contact-form__input contact-form__input--checkbox" formControlName="electronic" />
			<label for="electronic" class="checkbox__box">
				<i class="fa fa-check checkbox__check" [ngClass]="{'checkbox__check--active': userForm.controls['electronic'].value}"></i>
			</label>
			<div class="checkbox__label">{{ 'FORM.LABEL.ELECTRONIC' | translate }}</div>
		</div>
	</div>
	
	<div class="contact-form__actionbar">
		<div class="button button--gray" (tap)="onResetForm()">{{ 'FORM.BUTTON.RESET' | translate}}</div>
		<a [routerLink]="'/send'" class="button" *ngIf="userForm.valid">{{ 'FORM.BUTTON.SUBMIT' | translate}}  <i class="button__icon fa fa-angle-right"></i></a>
		<div class="button button--deactivated" *ngIf="userForm.invalid">{{ 'FORM.BUTTON.SUBMIT' | translate}}  <i class="button__icon fa fa-angle-right"></i></div>
	</div>
</form>
<div class="expo" *ngIf="environment.expoBuild">
	<h2 class="expo__title">Follow us on your mobile device!</h2>
	<h3 class="expo__subtitle">Explore the Hess Smart City</h3>
	<img src="assets/images/qrcode.svg" class="expo__code" />
</div>



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/form/form.component.html